import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {Subscription} from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-choix-langue',
    templateUrl: './modal-choix-langue.component.html',
    styleUrls: ['./modal-choix-langue.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatRadioGroup, FormsModule, MatRadioButton, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalChoixLangueComponent implements OnInit, OnDestroy {
    data = inject(MAT_DIALOG_DATA);


    private subscriptions: Subscription[] = [];
    public langue = 'fr';


    ngOnInit() {}
    ngOnDestroy(): void {
        this.subscriptions.forEach(item => item.unsubscribe());
    }
}
